/* eslint-disable import/no-anonymous-default-export */
export default {
    temperature: 'Temperature',
    humidity: 'Humidity',
    air_pressure: 'Air Pressure',
    co2: 'CO2',
    humiture: 'Temperature & Humidity',
    pm2510: 'PM2.5 & PM10',
    etvoc: 'eTVOC',
    noise: 'Noise',
    light: 'Light',
}